// Preserve the server's title on the first page load. CMS SEO overrides and
// SSR templates may differ from the client fallback; navigations still use
// the destination page's own metadata.
const initialPath = typeof window === "undefined" ? "" : window.location.pathname;
const initialTitle = typeof document === "undefined" ? "" : document.title;
let navigated = false;

export function initialSsrTitle(path: string): string | null {
  if (path !== initialPath) navigated = true;
  return !navigated && path === initialPath && initialTitle ? initialTitle : null;
}